module.exports = __webpack_public_path__ + "8eb796a47fb99ffb5369728f601d96c4.png";